module.exports = __webpack_public_path__ + "img/convertible.2aad782d.svg";